// extracted by mini-css-extract-plugin
export var errorIcon = "_io-1";
export var nameLogo = "_io-0";